import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

let snackbarFunction = null;

// Set the global enqueueSnackbar function
export const setSnackbar = (enqueueSnackbar) => {
  snackbarFunction = enqueueSnackbar;
};

const request = (options) => {
  //Request header options
  let headers;
  if (options.headers) {
    headers = options.headers;
  } else {
    headers = {
      "Content-Type": "application/json",
    };
  }

  //Assigning authorization token to the header object
  if (localStorage.getItem("cred")) {
    let token = JSON.parse(localStorage.getItem("cred")).token;

    Object.assign(headers, { Authorization: "Bearer " + token });
  }

  //Assigning header to options
  Object.assign(options, { headers });

  //Actual axios request
  return axios(options)
    .then((res) => {
      // A successful change to any Warning Dashboard setting (a threshold, a slab, an expense...) makes every result
      // the dashboard remembered out of date. Announce it; the dashboard's own memory (dashboardCache.js) listens.
      // An event, not an import, so this file stays free of the dashboard code.
      if (options.method && String(options.method).toLowerCase() !== 'get' && String(options.url || '').includes('warning-dashboard/') && res.data?.status === 'success') {
        window.dispatchEvent(new Event('warning-dashboard-config-changed'));
      }
      return res.data;
    })
    .catch((err) => {
      console.log("error in request", err.response);
      if (err.response?.status === 440) {
        // Display snackbar message globally
        if (snackbarFunction) {
          snackbarFunction("Token expired...! Please login..", {
            variant: "error",
          });
        }
        // Logout procedure
        setTimeout(() => {
          localStorage.removeItem("cred");
          window.location.href = "/auth/login";
        }, 300);
      }
      return err.response.data;
    });
};

export default request;
